import { Page } from "v2/components";
import { View } from "./View";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "services/api";
import { getContractDisplayName } from "v2/utils/getContractDisplayName";

interface IResponse {
  id: string; //workspace_id
  workspaceRules?: Array<{
    params?: {
      payload?: {
        rules?: {
          rulesRegister?: {
            policyContractNumber?: string;
          };
        };
      };
    };
  }>;
  sellerOrganization: {
    id: string;
    corporateName: string;
  };
  buyerOrganization: {
    id: string;
    corporateName: string;
  };
  product: {
    id: string;
    name: string;
    productType: string;
    supplierOrganization: {
      id: string;
      corporateName: string;
    };
  };
}

export function ExportarMovimentacao() {
  const { workspaceId, templateId } = useParams() as {
    workspaceId: string;
    templateId: string;
  };

  const { data, isFetching, isFetched, isError } = useQuery({
    queryKey: ["pageDetail", workspaceId],
    queryFn: () => api.get(`/v2/workspaces/${workspaceId}/get-details`),
    select: (data) => data.data.data as IResponse,
  });

  return (
    <>
      {!isFetched && isFetching && <div>Loading...</div>}
      {!isFetched && isError && <div>Error...</div>}
      {data && (
        <Page title={getContractDisplayName(data)} backRoute={`/v2/workspaces/${workspaceId}`}>
          <Page.Tab name="Atividades" variant="free">
            <View />
          </Page.Tab>
          <Page.Tab name="Histórico" disabled />
          <Page.Tab name="Contrato" disabled />
        </Page>
      )}
    </>
  );
}
